var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEBE10",
    d: "M256 29.463c125.114 0 226.536 101.423 226.536 226.537S381.114 482.536 256 482.536 29.464 381.114 29.464 256 130.886 29.463 256 29.463z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M256 341.491c14.453 0 26.168 11.718 26.168 26.172 0 14.453-11.715 26.167-26.168 26.167s-26.171-11.714-26.171-26.167c0-14.454 11.718-26.172 26.171-26.172zm19.55-39.21c-.88 22.062-38.246 22.092-39.1-.008-3.778-37.803-13.443-127.552-13.135-163.073.311-10.946 9.383-17.427 20.989-19.899 3.578-.764 7.513-1.135 11.477-1.132 3.986.008 7.932.401 11.514 1.166 11.988 2.554 21.401 9.301 21.398 20.444l-.045 1.117-13.098 161.385z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.be3ca1f3015754babc269afb0851104b.svg";
export { ForwardRef as ReactComponent };